import axios, { AxiosResponse } from 'axios';
import { SchoolYearData } from '@/types';

const API_URL = process.env.VUE_APP_API_URL;

const resourceURL = `${API_URL}/scholen`;

export const getSchool = async (brin: any) => {
  if (!brin) {
    throw Error('brin required');
  }
  return axios({
    method: 'get',
    url: `${resourceURL}/${brin}`,
  });
};

export const listSchoolInspectieRapporten = (filter: any) => axios({
  method: 'get',
  url: `${API_URL}/inspectierapporten`,
  params: filter,
});

export const listSchoolBesturen = (filter: any) => axios({
  method: 'get',
  url: `${API_URL}/besturen`,
  params: filter,
});

export const listSchoolDependances = (filter: any) => axios({
  method: 'get',
  url: `${API_URL}/dependances`,
  params: filter,
});

export default {
  async listScholen(filter = {}) {
    return axios({
      method: 'GET',
      url: resourceURL,
      params: filter,
    });
  },
  async listSchoolJaren(filter: any = {}, schoolType = 'all'): Promise<AxiosResponse<SchoolYearData[]>> {
    if (!schoolType) { throw Error('schoolType required'); }
    return axios({
      method: 'get',
      url: `${API_URL}/jaren/${schoolType}`,
      params: filter,
    });
  },
  async listSchoolRendementen() {
    return axios({
      method: 'get',
      url: `${API_URL}/opendata_rendement`,
    });
  },
  async listSchoolGidsen(filter: any = {}) {
    return axios({
      method: 'get',
      url: `${API_URL}/schoolgidsen`,
      params: filter,
    });
  },
  async listSchoolPlannen(baseFilter = {}) {
    const filter = { ...baseFilter, 'where[document_type]': 'schoolplan' };
    return axios({
      method: 'get',
      url: `${API_URL}/schoolgidsen`,
      params: filter,
    });
  },
  async listSchoolOpendagen(filter: any = {}) {
    return axios({
      method: 'get',
      url: `${API_URL}/open_dagen`,
      params: filter,
    });
  },
  async listSchoolVideos(filter: any = {}) {
    return axios({
      method: 'get',
      url: `${API_URL}/videos`,
      params: filter,
    });
  },
  async listVMBOProfielen() {
    return axios({
      method: 'get',
      url: `${API_URL}/vmboProfielen/by_school`,
    });
  },

  get: getSchool,
  listInspectieRapporten: listSchoolInspectieRapporten,
  listBesturen: listSchoolBesturen,
  listDependances: listSchoolDependances,
};
